import { render } from "./Home.vue?vue&type=template&id=7c56ede4&scoped=true&ts=true"
import script from "./Home.vue?vue&type=script&lang=ts"
export * from "./Home.vue?vue&type=script&lang=ts"

import "./Home.vue?vue&type=style&index=0&id=7c56ede4&lang=less&scoped=true"

import exportComponent from "D:\\code\\hyz-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c56ede4"]])

export default __exports__